import useRisksmartUser from '@risksmart-app/components/src/hooks/useRisksmartUser';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalForm } from 'src/components/form/form/ModalForm';

import { useCreateSchedule } from '@/hooks/mutations/scheduler';

import ScheduleForm from './forms/ScheduleForm';
import type { ScheduleFormFieldData } from './forms/scheduleFormSchema';
import { defaultValues, ScheduleFormSchema } from './forms/scheduleFormSchema';
import { toCreateScheduleInput } from './forms/toCreateScheduleInput';

type Props = {
  onDismiss: (saved: boolean) => void;
};

const ScheduleModal: FC<Props> = ({ onDismiss }) => {
  const { t } = useTranslation('common');
  const { user } = useRisksmartUser();
  const { mutateAsync: createSchedule } = useCreateSchedule();

  const defaultData: ScheduleFormFieldData = {
    ...defaultValues,
    Owners: [{ type: 'user', value: user!.userId }],
  };

  // No post-save navigation: a schedule has no detail page to open.
  const onSave = async (values: ScheduleFormFieldData): Promise<void> => {
    await createSchedule(toCreateScheduleInput(values));
  };

  return (
    <ModalForm
      // Passing `values` would flip ModalWrapper into edit mode; this modal only
      // ever creates.
      i18n={t('scheduler')}
      defaultValues={defaultData}
      schema={ScheduleFormSchema}
      onSave={onSave}
      onDismiss={onDismiss}
      formId={'schedule-form'}
      visible={true}
      size={'medium'}
    >
      <ScheduleForm />
    </ModalForm>
  );
};

export default ScheduleModal;
